var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 71,
    fill: "#0088F5",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.207 65.087l5.944-2.097a29.998 29.998 0 00-3.146 5.294l-2.798-3.197zm-4.129.345l5.506 6.29-.797 1.993a1.666 1.666 0 00.367 1.797l.525.523c-2.84 3.2-4.407 6.549-5.927 11.105a1.667 1.667 0 002.108 2.109c4.557-1.52 7.905-3.087 11.106-5.927l.523.523a1.666 1.666 0 001.797.369l1.993-.797 6.29 5.505a1.667 1.667 0 002.67-.7l4.977-14.1a21.667 21.667 0 005.12-13.988v-5.8a1.667 1.667 0 00-1.668-1.667h-5.8a21.668 21.668 0 00-13.987 5.117L53.78 62.762a1.667 1.667 0 00-.7 2.668l-.002.002zm4.064 19.427c1.047-2.527 2.22-4.537 3.898-6.462l2.564 2.563c-1.925 1.679-3.935 2.852-6.462 3.899zm10.927-4.147l-.89-.89-5-5-.89-.89 1.183-2.958a26.664 26.664 0 014.514-7.45l.96-1.122A18.335 18.335 0 0181.868 56h4.134v4.134A18.334 18.334 0 0179.6 74.055l-1.122.96a26.67 26.67 0 01-7.45 4.514l-2.959 1.183zm8.846 4.082l-3.197-2.797a29.995 29.995 0 005.293-3.145l-2.096 5.942zM76 64.334a1.667 1.667 0 113.333 0 1.667 1.667 0 01-3.333 0zm1.667-5a5 5 0 100 10 5 5 0 000-10z",
    fill: "#fff"
  })));
}
export default SvgRocket;